import { defineStore } from 'pinia'
import type { RouteRecordRaw } from 'vue-router'
import type { SiteConfig } from '@/store/interface'
import { setTitle, setMeta, setIcon, setCountJs } from '/@/utils/web'
export const useSiteConfig = defineStore('siteConfig', {
	state: (): SiteConfig => {
		return {
			site: {
				host: 'host1',
				title: 'title1',
				company_name: 'company1',
				favicon: 'favicon1',
				seo_count_js: 'seo_count_js1',
				keywords: 'keywords1',
				description: 'description1',
				currency: 'usd',
				version: import.meta.env.VITE_VERSION || '',
			},
			headNav: [],
			// recordNumber: 'recordNumber1',
			// cdnUrlParams: 'cdnUrlParams1',
			initialize: false,
			userInitialize: false,
		}
	},
	actions: {
		setSiteConfig(site: SiteConfig['site']) {
			// 使用 this.$patch(state) 时 headNav 的类型异常，直接赋值
			// console.log(state)
			this.$state.site = site
			// 设置标题
			setTitle(site.title)
			// 设置关键字
			setMeta('keywords', site.keywords || '')
			// 设置描述
			setMeta('description', site.description || '')
			setIcon(site.favicon)
			// 设置统计js
			setCountJs(site.seo_count_js)
		},
		setHeadNav(headNav: RouteRecordRaw[]) {
			this.headNav = headNav
		},
		setInitialize(initialize: boolean) {
			this.initialize = initialize
		},
		setUserInitialize(userInitialize: boolean) {
			this.userInitialize = userInitialize
		},
	},
})
